// extracted by mini-css-extract-plugin
export default {"heading":"Instructor_heading__zOhQv","instructor-details":"Instructor_instructor-details__PvUAi","instructor":"Instructor_instructor__umcJD"};